import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'

export const getVentureCapitals = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).getVentureCapitals()
}

// Do Not Remove this line ===@import api client===
